import axios from 'axios'
import {post,fetch,patch,put} from '@/common/js/http.js'
import cookie from "./cookie"
import Vue from 'vue'
import VueRouter from 'vue-router'

const router = new VueRouter();
//登陆
//获取Appid
var uid =cookie.getCookie('uid');
// var uid ='100123';
// cookie.setCookie('uid',uid);
if(!uid){
  if(IsWeiXin()){//微信环境
      axios.post("login/getAppid").then(res=>{
      wxLogin(res.data.data);
    })
  }else{//普通登录
    router.push('/login');
    
  }
}
//微信登录
var local_url=window.location.href; //保存当前页面路径
function wxLogin(appId) {
  var url = "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" + appId + "&redirect_uri=" + encodeURIComponent(local_url) + "&response_type=code&scope=snsapi_userinfo&state=STATE#wechat_redirect";
  var code = getUrlParam("code");
  if (!code) {
    window.location = url;
  } else {
    var params={};
    params.code = code;
    axios.post('login/login',{"data":params}).then(res=>{
      //存储用户信息
      cookie.setCookie('uid',res.data.data.uid,7);
      cookie.setCookie('openid',res.data.data.openid,7);
      //截取
      local_url=local_url.split('/?');
      let start_url=local_url[0];
      let end_params='/#'+local_url[1].split('#')[1];
      let url=start_url+end_params;
      // console.log(local_url,url,'跳转链接');return;
      window.location.replace(url);
    });
  }
}
 /**
 * 判断是否是微信环境
 */
function IsWeiXin () {
    var ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    }
    return false;
};
function getUrlParam(name) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
    var r = window.location.search.substr(1).match(reg);
    if (r != null) return (r[2]);
    return null;
}
export {
  IsWeiXin
}






// WEBPACK FOOTER //
// ./src/common/js/login.js